export const variants = {
  primary: {
    height: '56px',
    borderWidth: '2px',
    focusRingColor: 'hero.plum',
    active: {
      background: 'hero.plum',
      border: null,
      text: 'text.lightest',
    },
    hover: {
      background: '#3d0440',
      border: null,
      text: 'text.lightest',
    },
  },
  secondary: {
    active: {
      background: 'background.lightest',
      border: 'background.lightest',
      text: 'hero.plum',
    },
    hover: {
      background: 'background.lightest',
      border: null,
      text: 'hero.plum',
    },
  },
  yellow: {
    active: {
      background: 'secondary.yellow',
      border: 'secondary.yellow',
      text: 'hero.plum',
    },
    hover: {
      background: 'secondary.yellow',
      border: null,
      text: 'hero.plum',
    },
  },
  lilac: {
    height: '56px',
    borderWidth: '2px',
    active: {
      background: 'hero.lilac',
      border: null,
      text: 'hero.plum',
    },
    hover: {
      background: 'hero.lilac',
      border: 'hero.plum',
      text: 'hero.plum',
    },
  },
  cancel: {
    active: {
      background: 'text.lightest',
      border: 'hero.red',
      text: 'status.errorPrimary',
    },
  },
  plumLilac: {
    height: '56px',
    borderWidth: '2px',
    focusRingColor: 'hero.plum',
    active: {
      background: 'hero.plum',
      border: null,
      text: 'text.lightest',
    },
    hover: {
      background: 'hero.lilac',
      border: 'hero.plum',
      text: 'hero.plum',
    },
  },
  dark: {
    height: '56px',
    borderWidth: '2px',
    focusRingColor: 'hero.plum',
    active: {
      background: null,
      border: null,
      text: 'text.lightest',
    },
    hover: {
      background: null,
      border: 'text.lightest',
      text: 'text.lightest',
    },
  },
  white: {
    height: '56px',
    borderWidth: '2px',
    active: {
      background: null,
      border: 'hero.plum',
      text: 'hero.plum',
    },
    hover: {
      background: 'hero.lilac',
      border: 'hero.plum',
      text: 'hero.plum',
    },
  },
  glass: {
    height: '56px',
    borderWidth: '1px',
    focusRingColor: 'text.lightest',
    active: {
      background: '#ffffff24',
      border: '#ffffff47',
      text: 'text.lightest',
    },
    hover: {
      background: '#ffffff24',
      border: '#ffffff',
      text: 'text.lightest',
    },
    extraStyles:
      'backdrop-filter: blur(24px); box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.12); overflow: hidden;',
    sheen: true,
  },
  glassLight: {
    height: '56px',
    borderWidth: '1px',
    focusRingColor: 'text.lightest',
    active: {
      background: '#ffffff55',
      border: '#ffffffa0',
      text: 'hero.plum',
    },
    hover: {
      background: '#ffffff70',
      border: '#ffffffc0',
      text: 'hero.plum',
    },
    extraStyles:
      'backdrop-filter: blur(24px); box-shadow: 0 8px 32px 4px rgba(0, 0, 0, 0.18); overflow: hidden;',
    sheen: true,
  },
};
